// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22Lpi","question":"styles_question__2uZV1","description":"styles_description__3vac_"};